'use strict';
var Country = (function () {
    function Country() {
    }
    return Country;
}());
export { Country };
var Item = (function () {
    function Item() {
    }
    return Item;
}());
export { Item };
var Brand = (function () {
    function Brand() {
    }
    return Brand;
}());
export { Brand };
var ShippingMethod = (function () {
    function ShippingMethod() {
    }
    return ShippingMethod;
}());
export { ShippingMethod };
var Status = (function () {
    function Status() {
    }
    return Status;
}());
export { Status };
var Address = (function () {
    function Address() {
    }
    return Address;
}());
export { Address };
var Contact = (function () {
    function Contact() {
    }
    return Contact;
}());
export { Contact };
var OrderType = (function () {
    function OrderType() {
    }
    return OrderType;
}());
export { OrderType };
var Order = (function () {
    function Order() {
    }
    return Order;
}());
export { Order };
//# sourceMappingURL=order.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.js
// module id = 801
// module chunks = 0